/**
 * @Author: v_jppjpeng
 * @Date: 2023-03-10 14:30:09
 * @Explain: loading
 */

import { Loading as TdLoading } from 'tdesign-react';

export default function Loading() {
  return (
    <div className="page-loading fixed">
      <TdLoading size="small" style={{ color: '#00a386' }} />
    </div>
  );
}
